<template>
	<div class="company-name-renderer">
		<CompanyName class="company-name-renderer__label" :params="{ value: params.value, deliveryLocationId: params.node?.group ? null : deliveryLocationIds[0] }" />
		<v-icon class="company-name-renderer__icon" :class="{ 'company-name-renderer__icon--active': isInPreplanning }" @click.stop="togglePreplanning">calendar_add_on</v-icon>
	</div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import CompanyName from '@/components/common/CompanyName.vue';

const PREPLANNING_KEY = 'SFA_PREPLANNING';

const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
});

const isInPreplanning = ref(false);

function getDeliveryLocationIds() {
	const node = props.params?.node;

	if (node?.group) {
		const ids = [];
		node.allLeafChildren?.forEach((child) => {
			const id = child?.data?.deliveryLocationId ?? child?.data?.id;
			if (id && !ids.includes(id)) ids.push(id);
		});
		return ids;
	}

	const id = props.params?.data?.deliveryLocationId ?? props.params?.data?.id;
	return id ? [id] : [];
}

const deliveryLocationIds = getDeliveryLocationIds();

onMounted(() => {
	if (!deliveryLocationIds.length) return;

	const storage = iframeDataBridge.getStorage();
	if (!storage) return;

	storage.get(PREPLANNING_KEY, (data) => {
		const preplanning = data || [];
		isInPreplanning.value = deliveryLocationIds.every((id) => preplanning.indexOf(id) >= 0);
	});
});

function togglePreplanning() {
	if (!deliveryLocationIds.length) return;

	const storage = iframeDataBridge.getStorage();
	if (!storage) return;

	storage.get(PREPLANNING_KEY, (data) => {
		let preplanning = data || [];

		if (isInPreplanning.value) {
			preplanning = preplanning.filter((id) => !deliveryLocationIds.includes(id));
		} else {
			deliveryLocationIds.forEach((id) => {
				if (!preplanning.includes(id)) preplanning.push(id);
			});
		}

		storage.save(PREPLANNING_KEY, preplanning);
		isInPreplanning.value = !isInPreplanning.value;

		nextTick(() => {
			props.params.api?.refreshCells({ force: true, columns: [props.params.column.getColId()] });
		});
	});
}
</script>

<style lang="scss">
.company-name-renderer {
	display: flex;
	align-items: center;
	height: 100%;

	&__label {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&__icon {
		font-size: 24px;
		margin-left: 8px;
		transition: color 0.15s;
		cursor: pointer;
		color: rgba(var(--v-theme-on-surface), 0.3);
		flex-shrink: 0;

		&--active {
			color: rgb(var(--v-theme-primary));

			&:hover {
				color: rgb(var(--v-theme-error), 0.8) !important;
			}
		}

		&:hover {
			color: rgb(var(--v-theme-primary));
		}
	}
}
</style>
